import { IQuestionItem } from '../../types/questionnaire'

const QuestionItem = ({
    question,
    selectedQuestion,
    setSelectedQuestion,
    isMobile,
    getQuestionResponseCount,
    onQuestionSelect,
    showResponseCount = true,
  }: {
    question: IQuestionItem,
    selectedQuestion: number | null,
    setSelectedQuestion: (question: number | null) => void,
    isMobile: boolean,
    getQuestionResponseCount: (questionId: number) => number,
    onQuestionSelect?: (questionId: number) => void,
    showResponseCount?: boolean,
  }) => {
    const isSelected = selectedQuestion === question.id;
    const biggerDesktop = window.innerWidth > 1500;
    const responseCount = showResponseCount ? getQuestionResponseCount(question.id) : 0;
    // const loremTestString = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.'
    
    return (
        <div
            style={{
            // padding: '0.75rem',
            paddingBottom: '0.75rem',
            // paddingTop: '0.3rem',
            borderRadius: '8px',
            // backgroundColor: isSelected ? '#f0f9ff' : 'white',
            borderColor: isSelected ? '#3b82f6' : '#e0e0e0',
            marginBottom: isMobile ? '1rem' : '1.5rem',
            display: 'flex',
            // alignItems: 'center',
            gap: '0.75rem',
            flexDirection: isMobile ? 'column' : 'row',
            // backgroundColor: 'red'
            //   border: '1px solid #e0e0e0'
            }}
        >
        <div className="form-check" 
        style={{ 
            // backgroundColor: 'blue',
            maxWidth: isMobile ? '100%' : biggerDesktop ? '85%': '70%' 
         }}
         >
          <label className="form-check-label" style={{ 
            cursor: 'pointer', 
            width: '100%',
            display: 'flex',           // Make label a flex container
            alignItems: 'flex-start',  // Align to top for long text
            gap: '0.5rem'            // Space between radio and text
        }}>
            <input 
              type="radio" 
              className="form-check-input" 
              name="questionRadios" 
              value={question.id}
              checked={isSelected}
              onChange={(e) => {
                // Handle selection here
                if (e.target.checked) {
                  setSelectedQuestion(question.id);
                  // console.log("QUESTION TEXT", question.text)
                  // Delay onQuestionSelect to allow Safari to render selection state
                  setTimeout(() => {
                    onQuestionSelect?.(question.id);
                  }, 100);
                }
              }}
              style={{
                opacity: 0,
                position: 'absolute',
                width: 0,
                height: 0,
                margin: 0,
                padding: 0,
                border: 'none',
                clip: 'rect(0,0,0,0)',  // Safari-specific hiding
                WebkitAppearance: 'none',
                appearance: 'none'
                // marginTop: '0.25rem',     // Increase margin to align with text baseline
                // flexShrink: 0,
                // position: 'relative',     // Ensure proper positioning
                // zIndex: 1,
                // WebkitAppearance: 'auto' as any
              }}
            />
            <span
              aria-hidden="true"
              style={{
                width: '16px',
                height: '16px',
                minWidth: '16px',
                borderRadius: '50%',
                border: `2px solid ${isSelected ? '#2F86DD' : '#c0c0c0'}`,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '2px',
                boxSizing: 'border-box',
                flexShrink: 0,
              }}
            >
              {isSelected && (
                <span
                  style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    backgroundColor: '#2F86DD',
                  }}
                />
              )}
            </span>
            <span style={{ color: isSelected ? '#2F86DD' : undefined }}>{question.text}</span>
            {/* {loremTestString} */}
          </label>
        </div>

        {showResponseCount && (
          <div
              style={{
                  marginLeft: isMobile ? undefined : 'auto',
                  display: 'flex',
                  alignItems: isMobile ? undefined : 'center',
                  gap: '0.25rem',
                  cursor: 'default',
              }}
          >
              <i className="fal fa-users text-primary"/>
              <span style={{ fontSize: '0.7rem', color: '#2f86dd' }}>{responseCount} responses</span>
          </div>
        )}
      </div>
    );
  };

export default QuestionItem;